import { defineNuxtPlugin } from '#app'
import { useVmStore } from '~/stores/vm'

export default defineNuxtPlugin((nuxtApp) => {
  // Initialize the Pinia-based vm store
  const vm = useVmStore()

  // Make it available via Nuxt's provide/inject (useNuxtApp().$vm)
  nuxtApp.provide('vm', vm)

  // Expose on window for console debugging
  if (process.client) {
    window.vm = vm
    console.log('🔓 window.vm is now available', vm)
  }
})